import jsCookie from 'js-cookie'
import { useFlags } from 'flagsmith/react'
import { IFlagsmithFeature } from 'flagsmith/types'

/* eslint @typescript-eslint/sort-type-constituents: "error" */
export type FeatureFlag =
  | 'ai_prefill_workflow'
  | 'beta'
  | 'british_grid_eastings_northings'
  | 'mobile_debug'
  | 'mobile_maintenance_mode'
  | 'mobile_permit_check_in'
  | 'mobile_prefetch_queries'
  | 'mobile_register_schedule_inspections'
  | 'mobile_rich_text_input'
  | 'mobile_storage_document_directory'
  | 'nest_api_testing'
  | 'observation_mobile_video_1080p'
  | 'open_ai_analytics'
  | 'organisation_companies'
  | 'procore_integration'
  | 'register_time_property'
  | 'test_feature_flag'
  | 'web_checklist_approval'
  | 'web_company_settings'
  | 'web_create_checklist_from_register'
  | 'web_inspections_overview'
  | 'web_kiosk_mode'
  | 'web_mfa_settings'
  | 'web_object_detection'
  | 'web_permit_check_in'
  | 'web_permit_request_participants'
  | 'web_project_map_configurator_edit_mode'
  | 'web_register_linking_checklist'
  | 'web_register_schedule_inspections'
  | 'web_register_status_to_draft'
  | 'web_register_template_schedule'
  | 'web_remote_briefings'
  | 'web_site_box_rams_appraisals'

const useFeatureFlags = <T extends FeatureFlag = FeatureFlag>(
  flags: T[],
): {
  flags: { [K in T]: IFlagsmithFeature }
} => {
  // In integration tests we don't have any feature flags on
  // If feature flags become relevant for integration tests then we should find a way to control the feature flags
  if (Constants.INTEGRATION_TEST) {
    // @ts-ignore
    return { flags: {} }
  }

  // Web E2E
  // In E2E tests the feature flags have to be set explicitly otherwise they are off
  if (!API.isMobile() && Constants.E2E) {
    const featuresCookie = jsCookie.get('sa.e2e.features')
    return {
      flags: featuresCookie ? JSON.parse(featuresCookie) : {},
    }
  } else if (Constants.E2E) {
    // @ts-ignore
    return { flags: {} }
  }

  const flagsmithFlags = useFlags(flags)

  // If a flag is not enabled we set it as false in the flags map
  // This allows users of this hook to use `flags.flagName` to check if a flag is enabled
  for (const key of Object.keys(flagsmithFlags)) {
    // @ts-ignore
    if (!flagsmithFlags[key]?.enabled) {
      // @ts-ignore
      flagsmithFlags[key] = false
    }
  }

  return {
    flags: flagsmithFlags as { [key in T]: IFlagsmithFeature },
  }
}

export default useFeatureFlags
